import React, { useState, useEffect, useRef } from "react";
import { Upload, Button, Input } from "antd";
import { PlusOutlined, DeleteRowOutlined, UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Modal } from "react-bootstrap";
import axios from "axios";
import api from "../../config.json";
import swal from "sweetalert";
import Table from '../../Common/table'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './QRCodeList.css'
import { cloneDeep } from "lodash";
// import { content } from "html2canvas/dist/types/css/property-descriptors/content";
const QRCodeList = ({ Heading }) => {
  const [fileList, setFileList] = useState([]);
  const [uploadList, setUploadList] = useState([]);
  const [remarks, setRemarks] = useState({}); // Track remarks for each image
  const [open, setOpen] = useState(false)



  useEffect(() => {
    Heading('Item Inspection QR')
    getAllImages()

  }, [])

  // Handling the file change
  const handleChange = ({ fileList: newFileList }) => {
    newFileList.forEach((one, idx) => {
      newFileList[idx] = one.originFileObj
    })
    setFileList(newFileList);
  };

  function changeFileName(originalFile, newFileName) {
    // Extract the extension from the original file name
    const originalExtension = originalFile.name.split('.').pop();

    // Check if the new file name already contains an extension
    if (!newFileName.includes('.')) {
      // Append the original file extension if not already provided
      newFileName = `${newFileName}.${originalExtension}`;
    }

    // Create a new File object with the same content and the new name
    const newFile = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    return newFile;
  }


  // Handle remark change for each file
  const handleRemarkChange = (event, index) => {
    const files = [...fileList]
    files[index] = changeFileName(files[index], event.target.value)
    setFileList(files);
  };

  // Function to preview the uploaded image
  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const imgWindow = window.open(src);
    imgWindow.document.write(`<img src='${src}' style='width:100%' />`);
  };

  // Function to handle image upload using Axios
  const handleUpload = () => {
    const formData1 = new FormData();
    fileList.forEach((file) => {
      formData1.append("files", file);
    });

    axios
      .post(api.api + "uploadImage", formData1, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((result) => {
        swal("Save Successfully");
        getAllImages();
        setOpen(false)
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          swal(`${err.response.data.message}`, { dangerMode: true });
        } else {
          swal(`${err}`);
        }
      });
  };

  const getAllImages = () => {
    axios.get(api.api + 'QR')
      .then((result) => {
        console.log(result.data, "hvhfvdhfs");
        setUploadList(result.data)
      })
      .catch((err) => {
        console.log(err);
      })

  }

  const handleRemove = (idx) => setFileList(fileList.filter((file, i) => i !== idx))

  const handleDeleteFile = (one) => {
    axios.delete(api.api + 'uploadImage/' + one._id)
      .then((result) => {
        getAllImages()
      })
      .catch((err) => {
        console.log(err);
      })
  }

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        axios
          .delete(api.api + "uploadImage/" + data._id, { data: data })
          .then(result => {
            // consol(result.data)
            if (result.data.ok === 1 && result.data.deletedCount === 1) {
              getAllImages();
            }
          })
          .catch(err => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }

          });
      }
    });
  }
  const customerRef = useRef(null);
  const demoFromHTML = async () => {
    const source = customerRef.current;

    // Wait for all images in the source element to be loaded
    const loadImages = () => {
      const images = source.getElementsByTagName('img');
      const promises = Array.from(images).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve; // Resolve in case of an error as well
          }
        });
      });
      return Promise.all(promises);
    };

    // Wait for images to load
    await loadImages();

    const table = source.querySelector('table'); // Target the table element
    const rows = Array.from(table.querySelectorAll('tr')); // Get all rows of the table

    const maxRowsPerPage = 25; // Set 25 rows per page
    const totalRows = rows.length;
    const numPages = Math.ceil(totalRows / maxRowsPerPage); // Calculate the number of pages needed

    const pdf = new jsPDF('landscape', 'pt', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const margin = 20;
    const marginWidth = margin;
    const marginHeight = margin;

    const availableWidth = pdfWidth - 2 * marginWidth;
    const availableHeight = pdfHeight - 2 * marginHeight;

    for (let page = 0; page < numPages; page++) {
      const canvas = await html2canvas(source, { scale: 2 });

      // Get only the rows for the current page (25 rows per page)
      const startRow = page * maxRowsPerPage;
      const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
      const currentRows = rows.slice(startRow, endRow);

      // Temporarily hide rows not belonging to the current page
      rows.forEach((row, index) => {
        row.style.display = index >= startRow && index < endRow ? '' : 'none';
      });

      // Re-render the canvas for the current page's content
      const canvasForPage = await html2canvas(source, { scale: 2 });
      const imgData = canvasForPage.toDataURL('image/jpeg', 0.7);

      const imgHeight = (canvasForPage.height * availableWidth) / canvasForPage.width;
      const position = marginHeight;

      // Add content to the PDF for the current page
      pdf.addImage(
        imgData,
        'JPEG',
        marginWidth,
        position,
        availableWidth,
        imgHeight > availableHeight ? availableHeight : imgHeight
      );

      if (page < numPages - 1) {
        pdf.addPage(); // Add a new page if it's not the last one
      }
    }

    // Restore all rows to be visible after generating the PDF
    rows.forEach(row => (row.style.display = ''));

    pdf.save(`QRCodes.pdf`);
  };
  const getSelectedList = () => uploadList.filter((one) => one.IsChecked);

  const columns = [

    {
      key: "Check", label: <input type="checkbox" checked={getSelectedList().length == uploadList.length && uploadList.length!==0} onChange={(e) => {
        const list = cloneDeep(uploadList);
        list.forEach((one) => one.IsChecked = e.currentTarget.checked);
        setUploadList(list);
      }} />, content: (obj) => <input type="checkbox" checked={obj.IsChecked} onChange={(e) => {
        const list = cloneDeep(uploadList);
        const index = list.findIndex((one) => one._id === obj._id);
        list[index].IsChecked = e.currentTarget.checked;
        setUploadList(list);
      }} />
    },
    { path: "ItemName", label: "Item Name" },
    { path: "ItemNumber", label: "Item Number" },
    { path: "Operation", label: "Operation" },
    { path: "InspectionName", label: "Inspection Type" },
    // {
    //   path: "View",
    //   content: (obj) => (
    //     <button
    //       type="button" className='btn ' onClick={() => { }}>
    //       <FontAwesomeIcon icon={faEye} color='red' />
    //     </button>

    //   ),
    // },
  ]

  const downloadPDF = async (qrCodeGroups) => {
    const pdf = new jsPDF("p", "mm", "a4");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `QrCodeList.pdf`
    );
    setOpen(false);
  };

  const groupIntoSetsOf24 = () => {
    const groupedArray = [];
    const arr = getSelectedList()
    for (let i = 0; i < arr.length; i += 24) {
      groupedArray.push(arr.slice(i, i + 24));
    }
    return groupedArray;
  }

  return (
    <div>
      {/* Upload Section */}
      {getSelectedList().length > 0 && <div style={{ width: 150, marginRight: 25 }} className="row text-right justify-content-end float-right mt-2 mb-2">
        <Button onClick={() => setOpen(true)} icon={<DownloadOutlined />}>Generate PDF</Button>
      </div>}

      {/* Display table for image previews with remarks */}
      <Table isCenter={true} sortColumn={{ path: "ItemName", order: "asc" }} columns={columns} data={uploadList} />

      <Modal
        backdrop={"static"}
        className=""
        size={"xl"}
        show={open}
        onHide={() => setOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Download QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="a4-sheet">
            {
              groupIntoSetsOf24() && groupIntoSetsOf24().length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(groupIntoSetsOf24())}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>

                  {groupIntoSetsOf24().map((group, index) => (
                    <div className="a4-sheet-scrollable">
                      <div
                        className="a4-page"
                        // key={pageIndex}
                        style={{ pageBreakAfter: "always" }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${Math.sqrt(
                              16
                            )}, 1fr)`, // 3 columns in each row
                            gridTemplateRows: `repeat(${Math.sqrt(16)}, auto)`, // 3 rows per page (auto height)
                            gap: "16px", // Optional: Adjust the gap between items as needed
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                        >
                          {group.map((one, index) => (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center"
                              key={index}
                              style={{ textAlign: "center" }}
                            >
                              <img width={100} height={100} src={one.QR} />
                              {/* Adjust the size of the QR code */}
                              <p
                                style={{ fontSize: "10px", color: "black" }}
                                className="bolder"
                              >
                                {one.ItemNumber}
                              </p>
                              <p
                                style={{ fontSize: "10px", color: "black" }}
                                className="bolder"
                              >
                                {one.Operation}
                              </p>
                              <p
                                style={{ fontSize: "10px", color: "black" }}
                                className="bolder"
                              >  {one.InspectionName}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Save Changes Button */}
      {/* <div className="text-right">
        <Button type="primary" onClick={handleUpload} style={{ marginTop: 16 }}>
          Save Changes
        </Button>
      </div> */}
    </div>
  );
};

export default QRCodeList;
